<template>
  <div class="bg-gray-100 w-full h-full">
    <div class="lg:flex justify-between items-center px-8 lg:px-20 py-8">
        <div class="flex flex-col lg:flex-row space-y-8 lg:space-y-0">
            <h2 class="text-2xl font-semibold">{{title}}</h2>
            <input type="text" :placeholder="work" class="ml-0 lg:ml-6 w-3/4 lg:w-52 h-8 rounded-sm border-gray-400 focus:border-gray-600 focus:ring-0">
        </div>
        <div class="flex space-x-4 mt-4">
            <div>
                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L9.414 11H13a1 1 0 100-2H9.414l1.293-1.293z" clip-rule="evenodd"></path></svg>    
            </div>  
            <div>
                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z" clip-rule="evenodd"></path></svg>
            </div>
        </div>
    </div>
    <div class="grid grid-cols-2 lg:grid-cols-8 pl-20 gap-6 text-gray-600 pr-20">
        <div class="flex flex-col w-28 border border-gray-300 overflow-hidden">
            <img src="../assets/img/location.png" class="h-40 w-28 rounded-md">
            <h3 class="text-sm text-blue-700 mt-3 px-2">Jaha</h3>
            <h4 class="text-xs px-2">yaha 500 kam</h4>
        </div>
        <div class="flex flex-col w-28 border border-gray-300 overflow-hidden">
            <img src="../assets/img/nepalgunj.jpg" class="h-40 w-28 rounded-md">
            <h3 class="text-sm text-blue-700 mt-3 px-2">Nepalgunj</h3>
            <h4 class="text-xs px-2">yaha 500 kam</h4>
        </div>
         <div class="flex flex-col w-28 border border-gray-300 overflow-hidden">
            <img src="../assets/img/location.png" class="h-40 w-28 rounded-md">
            <h3 class="text-sm text-blue-700 mt-3 px-2">Jaha</h3>
            <h4 class="text-xs px-2">yaha 500 kam</h4>
        </div>
        <div class="flex flex-col w-28 border border-gray-300 overflow-hidden">
            <img src="../assets/img/nepalgunj.jpg" class="h-40 w-28 rounded-md">
            <h3 class="text-sm text-blue-700 mt-3 px-2">Nepalgunj</h3>
            <h4 class="text-xs px-2">yaha 500 kam</h4>
        </div>
         <div class="flex flex-col w-28 border border-gray-300 overflow-hidden">
            <img src="../assets/img/location.png" class="h-40 w-28 rounded-md">
            <h3 class="text-sm text-blue-700 mt-3 px-2">Jaha</h3>
            <h4 class="text-xs px-2">yaha 500 kam</h4>
        </div>
        <div class="flex flex-col w-28 border border-gray-300 overflow-hidden">
            <img src="../assets/img/nepalgunj.jpg" class="h-40 w-28 rounded-md">
            <h3 class="text-sm text-blue-700 mt-3 px-2">Nepalgunj</h3>
            <h4 class="text-xs px-2">yaha 500 kam</h4>
        </div> <div class="flex flex-col w-28 border border-gray-300 overflow-hidden">
            <img src="../assets/img/location.png" class="h-40 w-28 rounded-md">
            <h3 class="text-sm text-blue-700 mt-3 px-2">Jaha</h3>
            <h4 class="text-xs px-2">yaha 500 kam</h4>
        </div>
        <div class="flex flex-col w-28 border border-gray-300 overflow-hidden">
            <img src="../assets/img/nepalgunj.jpg" class="h-40 w-28 rounded-md">
            <h3 class="text-sm text-blue-700 mt-3 px-2">Nepalgunj</h3>
            <h4 class="text-xs px-2">yaha 500 kam</h4>
        </div>
    </div>

  </div>
</template>

<script>
export default {
props: [
    'title',
    'work'
]
}
</script>

<style>

</style>